<template>
    <select
        :value="modelValue"
        class="w-full bg-surface-card text-white border-0 border-b border-white/30 px-2 py-2 focus:border-primary focus:outline-none"
        @change="$emit('update:modelValue', ($event.target as HTMLSelectElement).value)"
    >
        <option v-for="item in items" :key="String(item.value)" :value="item.value">
            {{ item.label }}
        </option>
    </select>
</template>

<script setup lang="ts">
    defineProps<{
        modelValue: string | number
        items: { label: string; value: string | number }[]
    }>()

    defineEmits<{
        'update:modelValue': [value: string | number]
    }>()
</script>
